import React from 'react';
import {Swiper, SwiperSlide} from 'swiper/react';
import {Navigation, A11y} from 'swiper';
import 'swiper/swiper.css';
import 'swiper/modules/navigation/navigation.scss';
import {convertOffers} from '../../services/offer.service';
import {OfferModel} from '../../models/offer.model';
import Offer from './Offer';
import {expressInterestInOffer, handleApiResponse, logJsError} from '../../services/api.service';
import {
	getFromStore,
	saveToStore,
	StorePath,
	storeSaveAction,
	useStoreActionsFromStore,
} from '../../services/store.service';
import {logger} from '../../services/utils.service';
import MessageModel from '../../models/message.model';
import {addLatestMessage} from "../../services/message.service";

const Offers = ({data}: {data: any}) => {
	const storeAction = useStoreActionsFromStore(storeSaveAction);
	const offers: OfferModel[] = convertOffers(data);
	const messages = getFromStore(StorePath.MESSAGES) as MessageModel[];

	const handleOfferSelected = (offerId: any): void => {
		const offer = offers.find((offer) => offer.id === offerId) as OfferModel;
		if (offer) {
			const typingTimeout = setTimeout(() => {
				saveToStore(storeAction, StorePath.AGENT_TYPING, true);
			}, 1300);
			logger('Selected offer', offer);
			expressInterestInOffer(offer)
				.then(handleApiResponse)
				.then((data: any) => {
					addLatestMessage(data.messages, messages, storeAction);
					saveToStore(storeAction, StorePath.AGENT_TYPING, false);
					clearTimeout(typingTimeout);
				})
				.catch((error) => {
					logJsError(error);
				});
		}
	};

	return (
		<>
			<Swiper modules={[Navigation, A11y]}
			        spaceBetween={offers.length > 1 ? 50: 0}
			        slidesPerView="auto"
			        pagination={false}
			        navigation>
				{offers.map(offer => {
					return (
						<SwiperSlide key={offer.id}>
							<Offer offer={offer} handleOfferSelected={handleOfferSelected}/>
						</SwiperSlide>
					);
				})}
			</Swiper>
		</>
	);
};

export default Offers;
